import React, { useEffect, useState, useRef } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import rightArrow from '../../images/arrow-right-blue-textlink.svg';
import '../../sass/components/flexibleModules/_components.halfHalfFixedImageScrollingSection.scss';
import VisibilitySensor from 'react-visibility-sensor';

const HalfHalfFixedImageScrollingSection = ({ data }) => {

    // const [fixedImage, setFixedImage] = useState(data.fixedHalfHalfRepeater[0]);
    // const [alternateSection, setAlternateSection] = useState(false);
    // const contentRef = useRef(null);

    // useEffect(() => {
    //     window.addEventListener("scroll", handleScroll);
    //     return () => window.removeEventListener("scroll", handleScroll);
    // }, []);

    // const handleScroll = (e) => {
    //     const contentSection = contentRef.current;
    //     if (contentSection) {
    //         const scrollTop = 0 - contentSection.getBoundingClientRect().top;
    //         if (scrollTop < 1000) {
    //             setFixedImage(data.fixedHalfHalfRepeater[0]);
    //             setAlternateSection(true);
    //         } else if (scrollTop < 1700) {
    //             setFixedImage(data.fixedHalfHalfRepeater[1] ? data.fixedHalfHalfRepeater[1] : data.fixedHalfHalfRepeater[0]);
    //             setAlternateSection(false);
    //         }
    //         else if (scrollTop < 2800) {
    //             setFixedImage(data.fixedHalfHalfRepeater[2] ? data.fixedHalfHalfRepeater[2] : data.fixedHalfHalfRepeater[1]);
    //             setAlternateSection(true);
    //         }
    //         else if (scrollTop < 3500) {
    //             setFixedImage(data.fixedHalfHalfRepeater[3] ? data.fixedHalfHalfRepeater[3] : data.fixedHalfHalfRepeater[1]);
    //             setAlternateSection(false);
    //         } else {
    //             setFixedImage(data.fixedHalfHalfRepeater[4] ? data.fixedHalfHalfRepeater[4] : data.fixedHalfHalfRepeater[1]);
    //             setAlternateSection(true);
    //         }
    //     }
    // };

    let lottieCheck = false;    
    useEffect(() => {
        if (data.fixedHalfHalfRepeater.length > 0) {
            var lengthCheck = data.fixedHalfHalfRepeater.length;
            for (var i = 0; i < lengthCheck; i++) {
                if (data.fixedHalfHalfRepeater[i].fixedHalfHalfRepeaterLottieFile == 'yes') {
                    if (!lottieCheck) {
                        var scriptOne = document.createElement('script');
                        scriptOne.src = 'https://unpkg.com/@lottiefiles/lottie-player@2.0.12/dist/lottie-player.js';
                        document.getElementsByTagName('head')[0].appendChild(scriptOne);
                        lottieCheck = true;
                    }
                }
            }
        }
    }, [lottieCheck]);

    const [lottieFileOne, setLottieFileOne] = useState(false);
    const [lottieFileTwo, setLottieFileTwo] = useState(false);
    const [lottieFileThree, setLottieFileThree] = useState(false);

    function onChange(isVisible, index) {
        if (isVisible && index === 0) {
            setLottieFileOne(true);
        }
        if (isVisible && index === 1) {
            setLottieFileTwo(true);
        }
        if (isVisible && index === 2) {
            setLottieFileThree(true);
        }
    }

    return (
        <div className={`cp-halfHalfFixedScrolling ${data.overrideClass && data.overrideClass==='l-bgChange' ? data.overrideClass : ""}`}>
            <div className={`cp-halfHalfFixedScrolling__inner ${data.overrideClass ? data.overrideClass : "l-noOverride"}`} style={{ maxWidth: `${data.maxWidth ? (data.maxWidth/16+"rem") : ""}`, margin: "0 auto" }}>
                {data.fixedHalfHalfRepeater &&
                    <>
                        {data.fixedHalfHalfRepeater.map((fixedSection, index) => (
                            <div className="l-fixedScroll l--flex" key={index}>
                                <div className="cp-halfHalfFixedScrolling__left" data-sal-duration="800" data-sal="slide-up" data-sal-delay="300" data-sal-easing="ease">
                                    <div className="l-fixedScroll__content l--flex" style={{ backgroundColor: fixedSection.fixedHalfHalfRepeaterContentBackground }}>
                                        <div className="l-fixedScroll__content-inner l--flex">
                                            <div>
                                                <h3 dangerouslySetInnerHTML={{ __html: fixedSection.header }} />
                                                <p dangerouslySetInnerHTML={{ __html: fixedSection.teaser }} />
                                                {fixedSection.textLink &&
                                                    <a href={fixedSection.textLink.url} target={fixedSection.textLink.target} className="l-textLink"><span>{fixedSection.textLink.title}</span><img loading="lazy" src={rightArrow} alt="right arrow" /></a>
                                                }
                                            </div>
                                            {fixedSection.customerQuoteCheck === 'yes' &&
                                                <div className="cp-halfSectionCustomerStory" style={{ maxWidth: `${data.maxWidth}px` }}>
                                                    <div className="cp-halfSectionCustomerStory__inner">
                                                        <p dangerouslySetInnerHTML={{ __html: fixedSection.customerReviewTeaser }} />
                                                        <div className="cp-halfSectionCustomerStory__author l--flex">
                                                            {fixedSection.customerReviewThumb &&
                                                                <GatsbyImage image={getImage(fixedSection.customerReviewThumb.gatsbyImage)} alt={fixedSection.customerReviewThumb.altText} />
                                                            }
                                                            <div className="cp-halfSectionCustomerStory__author-details">
                                                                {fixedSection.customerReviewName &&
                                                                    <span>{fixedSection.customerReviewName}</span>
                                                                }
                                                                {fixedSection.customerReviewTitle &&
                                                                    <span dangerouslySetInnerHTML={{ __html: fixedSection.customerReviewTitle }} />
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="cp-halfHalfFixedScrolling__right" style={{ backgroundColor: fixedSection.fixedHalfHalfRepeaterImageBackground }}>
                                    <div className="l-fixedScroll__image" data-sal="slide-up" data-sal-duration="800" data-sal-delay="300" data-sal-easing="ease">
                                        {fixedSection.fixedHalfHalfRepeaterLottieFile === 'yes' ?
                                            <VisibilitySensor onChange={(e) => onChange(e, index)}>
                                                <>
                                                    {lottieFileOne || lottieFileTwo || lottieFileThree ?
                                                        <>
                                                            {lottieFileOne && index === 0 || lottieFileTwo && index === 1 || lottieFileThree && index === 2 ?
                                                                <lottie-player src={fixedSection.fixedHalfHalfRepeaterLottieFileLink} background="transparent" speed="1" autoplay></lottie-player>
                                                                :
                                                                <p>Not Loaded</p>
                                                            }
                                                        </>
                                                        :
                                                        <p>Not Loaded</p>
                                                    }
                                                </>
                                            </VisibilitySensor>
                                            :
                                            <>
                                                {fixedSection.fixedHalfHalfRepeaterImage &&
                                                    <GatsbyImage image={getImage(fixedSection.fixedHalfHalfRepeaterImage.gatsbyImage)} alt={fixedSection.fixedHalfHalfRepeaterImage.altText} />
                                                }
                                            </>
                                        }
                                        {/* {fixedSection.fixedHalfHalfRepeaterPatternCheck === 'yes' &&
                                            <div className="l-absolute">
                                                <span className="l-absolutePattern"></span>
                                            </div>
                                        } */}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </>
                }
            </div>
        </div>
    );
}

export default HalfHalfFixedImageScrollingSection;